import { LoadingButton } from "@mui/lab";
import { Card, Stack, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import useLocales from "src/hooks/useLocales";

import { useGetApp } from "./hook/useGetApp";
import SectionTitle from "./SectionTitle";
import useUpdateApp from "./services/useUpdateApp";

// ----------------------------------------------------------------------

export const NameAppCard = () => {
	const app = useGetApp();

	const [name, setName] = useState(app?.name ?? "");

	const { isLoading, updateApp } = useUpdateApp();
	const { translate } = useLocales();

	const onClick = () => {
		updateApp(name);
	};

	useEffect(() => {
		if (app) setName(app.name);
	}, [app]);

	return (
		<Card sx={{ maxWidth: 800, p: 3 }}>
			<SectionTitle
				title={translate("app_settings.app_name")}
				description={translate("app_settings.app_name_description")}
			/>
			<Stack sx={{ mt: 3 }} flexDirection={"row"} alignItems='center' gap={3}>
				<TextField
					label={translate("app_settings.short_app_name")}
					value={name}
					sx={{ width: { xs: "auto", sm: 300 } }}
					onChange={(event) => setName(event.target.value)}
				/>
				<LoadingButton
					variant='contained'
					disabled={name.length === 0 || name === app?.name}
					onClick={onClick}
					loading={isLoading}
				>
					{translate("app_settings.save")}
				</LoadingButton>
			</Stack>
		</Card>
	);
};

export default NameAppCard;
